import React from 'react'

export default () => (
    <div>
		User
	</div>
)